import { sub } from "date-fns";
import path from "path";

export const clientMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/client',
		icon: 'Dashboard',
		subMenu: null,
	},
	// documents: {
	// 	id: 'documents',
	// 	text: 'Documents',
	// 	path: '/client/documents',
	// 	icon: 'sticky_note_2',
	// 	notification: 'info',
	// },
	history: {
		id: 'history',
		text: 'History',
		path: '/client/history',
		icon: 'AutoStories',
	},
	news: {
		id: 'news',
		text: 'News',
		path: '/client/news',
		icon: 'NewsPaper',
	},
	analysis: {
		id: 'analysis',
		text: 'Analysis',
		path: '/client/analysis',
		icon: 'Analytics',
		subMenu: {
			chartWidget: {
				id: 'chartWidget',
				text: 'Chart Widget',
				path: 'analysis/chartwidget',
				icon: 'AreaChart',
			},
			economicCalendar: {
				id: 'economicCalendar',
				text: 'Economic Calendar',
				path: 'analysis/economiccalendar',
				icon: 'CalendarToday',
			},
			ticker: {
				id: 'ticker',
				text: 'Ticker',
				path: 'analysis/ticker',
				icon: 'ViewDay',
			},
		},
	},
	platforms: {
		id: 'platforms',
		text: 'Platforms',
		path: '/client/platforms',
		icon: 'Dvr',
	},
	withdraw: {
		id: 'withdraw',
		text: 'Withdraw',
		path: '/client/withdraw',
		icon: 'Money',
	},
	loan: {
		id: 'loan',
		text: 'Loan',
		path: '/client/loan',
		icon: 'AccountBalance',
	},
	deposit: {
		id: 'deposit',
		text: 'Deposit',
		path: '/client/deposit',
		icon: 'Paid',
	},
	marginCalculator: {
		id: 'calculator',
		text: 'Margin Calculator',
		path: '/client/marginCalculator',
		icon: 'Calculate',
	},
	mail: {
		id: 'mail',
		text: 'Mail',
		path: '/client/mail',
		icon: 'mail',
	},
	educationcenter: {
		id: 'educationcenter',
		text: 'Education Center',
		path: '/client/educationcenter',
		icon: 'School',
	},
};

export const clientMenuWithoutDoc = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/client/',
		icon: 'Dashboard',
		subMenu: null,
	},
	history: {
		id: 'history',
		text: 'History',
		path: '/client/history',
		icon: 'AutoStories',
	},
	analysis: {
		id: 'analysis',
		text: 'Analysis',
		path: '/client/analysis',
		icon: 'Analytics',
		subMenu: {
			listchartWidgetBoxed: {
				id: 'chartWidget',
				text: 'Chart Widget',
				path: 'analysis/chartwidget',
				icon: 'AreaChart',
			},
			economicCalendar: {
				id: 'economicCalendar',
				text: 'Economic Calendar',
				path: 'analysis/economiccalendar',
				icon: 'CalendarToday',
			},
			ticker: {
				id: 'ticker',
				text: 'Ticker',
				path: 'analysis/ticker',
				icon: 'ViewDay',
			},
		},
	},
	platforms: {
		id: 'platforms',
		text: 'Platforms',
		path: '/client/platforms',
		icon: 'Dvr',
	},
	withdraw: {
		id: 'withdraw',
		text: 'Withdraw',
		path: '/client/withdraw',
		icon: 'Money',
	},
	loan: {
		id: 'loan',
		text: 'Loan',
		path: '/client/loan',
		icon: 'AccountBalance',
	},
	educationcenter: {
		id: 'educationcenter',
		text: 'Education Center',
		path: '/client/educationcenter',
		icon: 'School',
	},
};

export const adminMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/admin',
		icon: 'Dashboard',
	},
	customer: {
		id: 'customer',
		text: 'Customer',
		path: '/admin/customer',
		hide: true,
	},
	clients: {
		id: 'clients',
		text: 'Clients',
		path: '/admin/clients',
		icon: 'People',
	},
	leads:{
		id: 'leads',
		text: 'Leads',
		path: '/admin/leads',
		icon: 'AdsClick',
		subMenu :{
			allLeads:{
				id: 'allLeads',
				text: 'All Leads',
				path: '/admin/leads',
				icon: 'List',
			},
			leadAssignments:{
				id: 'leadAssignments',
				text: 'Lead Assignments',
				path: '/admin/leads/leadAssignments',
				icon: 'AssignmentInd',
			}
			
		}
	},
	agentMappings:{
				id: 'agentMappings',
				text: 'ClickToCall Agent Mapping',
				path: '/admin/leads/agentMappings',
				icon: 'PhoneIphone',
			},
	banks: {
		id: 'banks',
		text: 'Banks',
		path: '/admin/banks',
		icon: 'AccountBalance',
	},
	withdraw: {
		id: 'withdraw',
		text: 'Pending Withdrawal Requests',
		path: '/admin/withdraw',
		icon: 'Money',
	},
	deposit: {
		id: 'deposit',
		text: 'Pending deposit Requests',
		path: '/admin/deposit',
		icon: 'Paid',
	},
	loan: {
		id: 'loan',
		text: 'Pending Loan Requests',
		path: '/admin/loan',
		icon: 'AccountBalance',
	},
	mail: {
		id: 'mail',
		text: 'Mail',
		path: '/admin/mail',
		icon: 'mail',
	},
	educationcenter: {
		id: 'educationcenter',
		text: 'Education Center',
		path: '/admin/educationcenter',
		icon: 'School',
	},
	analysis: {
		id: 'analysis',
		text: 'Analysis',
		path: '/admin/analysis',
		icon: 'Analytics',
		subMenu: {
			chartWidget: {
				id: 'chartWidget',
				text: 'Chart Widget',
				path: '/admin/analysis/chartwidget',
				icon: 'AreaChart',
			},
			economicCalendar: {
				id: 'economicCalendar',
				text: 'Economic Calendar',
				path: '/admin/analysis/economiccalendar',
				icon: 'CalendarToday',
			},
			ticker: {
				id: 'ticker',
				text: 'Ticker',
				path: '/admin/analysis/ticker',
				icon: 'ViewDay',
			},
		},
	},
	reports: {
		id: 'reports',
		text: 'Reports',
		path: '/admin/reports',
		icon: 'Analytics',
		subMenu: {
			transactionsReport: {
				id: 'transactionsReport',
				text: 'Transactions Report',
				path: '/admin/reports/transactionsReport',
				icon: 'AreaChart',
			},
			moneyTransactionsReport: {
				id: 'moneyTransactionsReport',
				text: 'Money Transactions Report',
				path: '/admin/reports/moneyTransactionsReport',
				icon: 'CalendarToday',
			},
			firstDeposit: {
				id: 'firstDeposit',
				text: 'First Deposits',
				path: '/admin/reports/firstDeposit',
				icon: 'ViewDay',
			},
			repeatedDeposit: {
				id: 'repeatedDeposit',
				text: 'Repeated Deposits',
				path: '/admin/reports/repeatedDeposit',
				icon: 'ViewDay',
			},
			todaysLiquidateAccount: {
				id: 'todaysLiquidateAccount',
				text: 'Liquidated Accounts',
				path: '/admin/reports/todaysLiquidateAccount',
				icon: 'ViewDay',
			},
			activeAccountsWithFunds: {
				id: 'activeAccountsWithFunds',
				text: 'Active Accounts',
				path: '/admin/reports/activeAccountsWithFunds',
				icon: 'ViewDay',
			},
			semiInactiveAccounts: {
				id: 'semiInactiveAccounts',
				text: 'Semi Inactive Accounts',
				path: '/admin/reports/semiInactiveAccounts',
				icon: 'ViewDay',
			},
			inactiveAccountsWithFunds: {
				id: 'inactiveAccountsWithFunds',
				text: 'Fully Inactive Accounts',
				path: '/admin/reports/inactiveAccountsWithFunds',
				icon: 'ViewDay',
			},
			topXWinners: {
				id: 'topXWinners',
				text: 'Top X Winners',
				path: '/admin/reports/topXWinners',
				icon: 'ViewDay',
			},
			topXLoosers: {
				id: 'topXLoosers',
				text: 'Top X Loosers',
				path: '/admin/reports/topXLoosers',
				icon: 'ViewDay',
			},
			accountWithoutMoneyTransaction: {
				id: 'accountWithoutMoneyTransaction',
				text: 'No FTD Accounts',
				path: '/admin/reports/accountWithoutMoneyTransaction',
				icon: 'ViewDay',
			},
			usersDetailsReport: {
				id: 'usersDetailsReport',
				text: 'Users Details Report',
				path: '/admin/reports/usersDetailsReport',
				icon: 'ViewDay',
			},
			openPositionsReport: {
				id: 'openPositionsReport',
				text: 'Open Positions Report',
				path: '/admin/reports/openPositionsReport',
				icon: 'ViewDay',
				subMenu: {
					detailedOpenPositionsReport: {
						id: 'detailedOpenPositionsReport',
						text: 'Detailed Open Positions Report',
						path: '/admin/reports/openPositionsReport/detailedOpenPositionsReport',
						icon: 'ViewDay',
					},
				},
			},
			historyReport: {
				id: 'historyReport',
				text: 'History Report',
				path: '/admin/reports/historyReport',
				icon: 'ViewDay',
				subMenu: {
					detailedOpenHistoryReport: {
						id: 'detailedOpenHistoryReport',
						text: 'Detailed Open History Report',
						path: '/admin/reports/historyReport/detailedOpenHistoryReport',
						icon: 'ViewDay',
					},
					detailedCloseHistoryReport: {
						id: 'detailedCloseHistoryReport',
						text: 'Detailed Close History Report',
						path: '/admin/reports/historyReport/detailedCloseHistoryReport',
						icon: 'ViewDay',
					},
				},
			},
			pendingOrdersReport: {
				id: 'pendingOrdersReport',
				text: 'Pending Orders Report',
				path: '/admin/reports/pendingOrdersReport',
				icon: 'AreaChart',
			},
			financialStandingReport: {
				id: 'financialStandingReport',
				text: 'Financial Standing Report',
				path: '/admin/reports/financialStandingReport',
				icon: 'AreaChart',
				subMenu: {
					detailedFinancialStandingReport: {
						id: 'detailedFinancialStandingReport',
						text: 'Detailed Financial Standing Report',
						path: '/admin/reports/financialStandingReport/detailedFinancialStandingReport',
						icon: 'ViewDay',
					},
					financialStandingHistoryReport: {
						id: 'financialStandingHistoryReport',
						text: 'Financial Standing History Report',
						path: '/admin/reports/financialStandingReport/financialStandingHistoryReport',
						icon: 'ViewDay',
					},
				},
			},
			loginReport: {
				id: 'loginReport',
				text: 'Login Report',
				path: '/admin/reports/loginReport',
				icon: 'AreaChart',
			},
			OtpLogsReport: {
				id: 'otpLogsReport',
				text: 'Otp Logs Report',
				path: '/admin/reports/OtpLogsReport',
				icon: 'AreaChart',
			},
			roboOrdersHistory: {
				id: 'roboOrdersHistory',
				text: 'Robo Orders History',
				path: '/admin/reports/roboOrdersHistory',
				icon: 'AreaChart',
				subMenu: {
					openRoboOrdersHistory: {
						id: 'openRoboOrdersHistory',
						text: 'Open Robo Orders History',
						path: '/admin/reports/roboOrdersHistory/openRoboOrdersHistory',
						icon: 'ViewDay',
					},
					closeRoboOrdersHistory: {
						id: 'closeRoboOrdersHistory',
						text: 'Close Robo Orders History',
						path: '/admin/reports/roboOrdersHistory/closeRoboOrdersHistory',
						icon: 'ViewDay',
					},
				},
			},
			withdrawRequestsReport: {
				id: 'withdrawRequestsReport',
				text: 'Withdraw Requests Report',
				path: '/admin/reports/withdrawRequestsReport',
				icon: 'AreaChart',
			},
			loanRequestsReport: {
				id: 'loanRequestsReport',
				text: 'Loan Requests Report ',
				path: '/admin/reports/loanRequestsReport',
				icon: 'AreaChart',
			},
			depositRequestReport: {
				id: 'depositRequestReport',
				text: 'Deposit Request Report ',
				path: '/admin/reports/depositRequestReport',
				icon: 'AreaChart',
			},
			// tradeBookReport: {
			// 	id: 'tradeBookReport',
			// 	text: 'Trade Book Report',
			// 	path: '/admin/reports/tradeBookReport',
			// 	icon: 'AreaChart',
			// },
			journalReport: {
				id: 'journalReport',
				text: 'Journal Report',
				path: '/admin/reports/journalReport',
				icon: 'AreaChart',
			},
		},
	},
	otpService: {
		id: 'otpService',
		text: 'Otp Service',
		path: '/admin/otpService',
		icon: 'phone',
	},
	// publicSettings: {
	// 	id: 'publicSettings',
	// 	text: 'Public Settings',
	// 	path: '/admin/settings',
	// 	icon: 'settings',
	// },
};

export const demoPagesMenu = {
	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
	},

	forgotPassword: {
		id: 'forgotPassword',
		text: 'Forgot Password',
		path: 'auth-pages/forgotpassword',
		icon: 'PersonAdd',
	},
	resetPassword: {
		id: 'resetPassword',
		text: 'Reset Password',
		path: 'auth-pages/resetpassword',
		icon: 'PersonAdd',
	},
	createAccount: {
		id: 'createAccount',
		text: 'Create Account Step1',
		path: 'auth-pages/create-account/step1/:parentId?',
		icon: 'PersonAdd',
	},
	// createAccount2: {
	// 	id: 'createAccount2',
	// 	text: 'Create Account Step2',
	// 	path: 'auth-pages/create-account/step2',
	// 	icon: 'PersonAdd',
	// },
	// createAccount3: {
	// 	id: 'createAccount3',
	// 	text: 'Create Account Step3',
	// 	path: 'auth-pages/create-account/step3',
	// 	icon: 'PersonAdd',
	// },
	encryptText: {
		id: 'encryptText',
		text: 'Encrypt Text',
		path: 'encrypt/:text',
		icon: 'PersonAdd',
	},

	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'Page Layout Types',
	},
	blank: {
		id: 'blank',
		text: 'Blank',
		path: 'page-layouts/blank',
		icon: 'check_box_outline_blank ',
	},
	pageLayout: {
		id: 'pageLayout',
		text: 'Page Layout',
		path: 'page-layouts',
		icon: 'BackupTable',
		subMenu: {
			headerAndSubheader: {
				id: 'headerAndSubheader',
				text: 'Header & Subheader',
				path: 'page-layouts/header-and-subheader',
				icon: 'ViewAgenda',
			},
			onlyHeader: {
				id: 'onlyHeader',
				text: 'Only Header',
				path: 'page-layouts/only-header',
				icon: 'ViewStream',
			},
			onlySubheader: {
				id: 'onlySubheader',
				text: 'Only Subheader',
				path: 'page-layouts/only-subheader',
				icon: 'ViewStream',
			},
			onlyContent: {
				id: 'onlyContent',
				text: 'Only Content',
				path: 'page-layouts/only-content',
				icon: 'WebAsset',
			},
		},
	},
	asideTypes: {
		id: 'asideTypes',
		text: 'Aside Types',
		path: 'aside-types',
		icon: 'Vertical Split',
		subMenu: {
			defaultAside: {
				id: 'defaultAside',
				text: 'Default Aside',
				path: 'aside-types/default-aside',
				icon: 'ViewQuilt',
			},
			minimizeAside: {
				id: 'minimizeAside',
				text: 'Minimize Aside',
				path: 'aside-types/minimize-aside',
				icon: 'View Compact',
			},
		},
	},
};
